import { DbAccesses } from "@p0security/integrations-db";
import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { MysqlComponents } from "./components.ts";

const MysqlFilters = {
  instance: { keys: ["name"] },
  role: { keys: ["name"] },
} as const satisfies AnyFilterSchema;

export type MysqlFilters = typeof MysqlFilters;

export const MysqlRegistration = Registration({
  accesses: DbAccesses,
  category: "resource",
  components: MysqlComponents,
  docs: {
    install: "mysql",
    request: "mysql/requesting-access",
  },
  filters: MysqlFilters,
  itemKind: "instance",
  label: "MySQL",
  logoUrl: "https://www.mysql.com/common/logos/logo-mysql-170x115.png",
  maturity: "preview",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "iam-write" }],
});

registerIntegration("mysql", MysqlRegistration);
